import { connect } from 'react-redux';

import { GET_LIST_ROOM_OF_PLACE, UPDATE_NUMBER_AVAILABLE_ROOM } from 'store/place/actionTypes';

import AmountRoom from './AmountRoom';

const mapStateToProps = (state) => ({
  isLoadingUpdateAvailableRoom: state.Place.isLoadingUpdateAvailableRoom,

  roomOfPlaceList: state.Place.roomOfPlaceList,
});

const mapDispatchToProps = (dispatch) => ({
  actionGetListRoomsOfPlace: (payload) => dispatch({
    type: GET_LIST_ROOM_OF_PLACE,
    payload,
  }),

  actionUpdateAvailableRoom: (payload) => dispatch({
    type: UPDATE_NUMBER_AVAILABLE_ROOM,
    payload,
  }),
});

export default connect(mapStateToProps, mapDispatchToProps)(AmountRoom);
